import React from 'react';

type EmptyStateProps = {
  id?: string;
  message: string;
  actionLabel?: string;
  onAction?: () => void;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ id, message, actionLabel, onAction }) => {
  const baseId = id || 'empty-state';

  return (
    <div id={baseId} data-testid={baseId} className="tw-flex-1 tw-overflow-auto tw-px-2 tw-flex tw-items-center tw-justify-center">
      <div id={`${baseId}-content`} className="tw-text-center">
        <p id={`${baseId}-message`} className="tw-text-gray-500 tw-mb-4">{message}</p>
        {actionLabel && onAction && (
          <button id={`${baseId}-action-btn`} data-testid={`${baseId}-action-btn`} className="button-style" onClick={onAction}>
            {actionLabel}
          </button>
        )}
      </div>
    </div>
  );
};
